import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { FilterStore } from './types'
import { createDraftsSlice } from './draftsSlice'
import { createAppliedSlice } from './appliedSlice'
import { createDefaultsSlice } from './defaultsSlice'
import { createOptionsSlice } from './optionsSlice'

export const useFilterStore = create<FilterStore>()(
  devtools((...a) => ({
    ...createDraftsSlice(...a),
    ...createAppliedSlice(...a),
    ...createDefaultsSlice(...a),
    ...createOptionsSlice(...a),
  })),
)
